import { fetchWrapper } from "./fetchWrapper";

export async function verifyVehicleNumber(body: { groupId: string, vehicleNumber: string }) {
    return fetchWrapper(`https://569hhsfu3h.execute-api.us-east-1.amazonaws.com/dev/verifyVehicleNumber`, {
        method: 'POST',
        body: body,
    });
}